<template>
    <div class="layout-main-container">
        <div class="layout-main">
            <div class="flex flex-wrap justify-content-center" style="margin-top: 0.5em;">
                <div v-for="request in requests" :key="request" class="flex join_request">
                    <Card style="width: 286px; height: 260px; margin: 5px;direction: rtl;">
                        <template #title>
                            <div
                                style="margin-top: 0.5em;word-wrap: break-word; text-align: center;direction: initial;">
                                {{ request.fileName }}
                            </div>
                        </template>
                        <template #content>
                            <div class="text-center" style="font-weight: bold; font-size: 0.8rem">
                                <img :src="request.user.imageUrl" class="user_avatar"
                                    @click="showUserInfo(request.user.id)" />
                                <div style="height: 2.5em;margin-bottom: 0.5em;">
                                    <div>
                                        {{ request.email }}
                                    </div>
                                    <div>
                                        {{ $t('BOOKS_FILE_UPLOAD_DATE') }}
                                    </div>
                                    <div>
                                        {{ new Date(request.requestDate).toLocaleDateString("en-UK") }}
                                    </div>
                                </div>
                                <div class="flex flex-row flex-wrap justify-content-around" style="margin-top: 0.7em;">
                                    <input style="display: none;" type="file" @change="upload($event, request.id)" />
                                    <Button class="flex action_button" @click="download(request.id)">
                                        <font-awesome-icon :icon="['fas', 'download']" />
                                    </Button>
                                    <Button class="flex action_button" @click="deny(request.id)">
                                        <font-awesome-icon :icon="['fa', 'ban']" />
                                    </Button>
                                    <Button class="flex action_button" @click="selectUploadedFile">
                                        <font-awesome-icon :icon="['fas', 'upload']" />
                                    </Button>
                                    <Button class="flex action_button" @click="accept(request.id)">
                                        <font-awesome-icon :icon="['fas', 'thumbs-up']" />
                                    </Button>
                                </div>
                            </div>
                        </template>
                    </Card>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onErrorCaptured, onBeforeMount } from 'vue'
import { handleError } from '@/helpers/ErrorHandler'
import { useToast } from 'primevue/usetoast'
import { useAuthStore } from '@/stores/auth'
import { useI18n } from 'vue-i18n'
import { useDialog } from 'primevue/usedialog'
import UserOverview from '@/components/UserOverview.vue'
import bookService from '@/service/BookService'

const authStore = useAuthStore()
const toast = useToast()
const i18n = useI18n()
const dialog = useDialog()

const requests = ref([])

onBeforeMount(async () => {
    try {
        loadPendingRequests()
    } catch (error) {
        handleError(authStore, toast, i18n, error)
    }
})

onErrorCaptured((err, instance, info) => {
    return handleError(authStore, toast, i18n, err, instance, info)
})

const showUserInfo = (userId) => {
    dialog.open(UserOverview, {
        props: {
            header: i18n.t('USER_INFO'),
            style: {
                width: '20em',
            },
            breakpoints: {
                '960px': '75vw',
                '640px': '90vw'
            },
            modal: true
        },
        data: {
            userId: userId,
        }
    })
}

const download = async (requestID) => {
    await bookService.donwloadUploadRequest(requestID)
}

const upload = async (event, requestID) => {
    const file = event.target.files[0]
    if (!file.name.endsWith('.csv')) {
        toast.add({ severity: 'error', summary: i18n.t('UPLOADED_FILE_SHOULD_BE_CSV'), detail: '', life: 3000 })
    } else {
        const response = await bookService.importBooks(requestID, file, file.name)
        toast.add({ severity: 'info', summary: response.message, detail: '', life: 3000 })
        loadPendingRequests()
    }
}

const accept = async (requestID) => {
    let response = await bookService.acceptImportBooks(requestID)
    toast.add({ severity: 'info', summary: response.message, detail: '', life: 3000 })
    loadPendingRequests()
}

const deny = async (requestID) => {
    let response = await bookService.denyImportBooks(requestID)
    toast.add({ severity: 'info', summary: response.message, detail: '', life: 3000 })
    loadPendingRequests()
}

const selectUploadedFile = () => {
    document.querySelector('input').value = null;
    document.querySelector('input').click()
}

const loadPendingRequests = async () => {
    const response = await bookService.getPendingImportRequests()
    requests.value = response.result.collection
}

</script>

<style scoped>
.join_request:deep(.p-card) {
    /* background: linear-gradient(158.19deg, #e8e2be -637.2%, #e5e3d7 75.94%) !important; */
    background: var(--blue-black-new-5);
    border-radius: 18px !important;
    border: 0.1px solid #dad8c7 !important;
}

#controls>* {
    margin-bottom: 1em;
}

#controls:deep(.p-button) {
    margin-left: 0.5em;
}

.user_avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    cursor: pointer;
}

.action_button {
    margin: 2px;
}
</style>